module.exports = __webpack_public_path__ + "static/img/MA.494f9d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MA.png
// module id = MzAG
// module chunks = 1